import {TFlatJsonStruct} from "@app/factory/flatJson";

type TJson = {
    [key: string]: string | TJson
}

export function gridDateToJson<T extends TFlatJsonStruct>(newData: T[]): TJson {

    let newJson: T = {} as T;

    for (let i = 0; i < newData.length; i++) {

        const splittedKey = newData[i].key.split('.')

        let s = newJson;

        let key = '';
        for (let ikey = 0; ikey < splittedKey.length; ikey++) {
            key = splittedKey[ikey];
            if (ikey === splittedKey.length - 1) {
                break;
            }
            s = assigning(s, key);
        }
        s[key] = newData[i].translate;
    }

    function assigning(obj, name) {
        if (obj[name]) {
            return obj[name];
        }
        return obj[name] = {};
    }

    return newJson
}
